var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15653_6059)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_15653_6059)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.05859 0.818359H25.8862V17.182H1.05859V0.818359Z",
  fill: "#3F9C35"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05859 0.818359H25.8862V11.7275H1.05859V0.818359Z",
  fill: "#ED2939"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05859 0.818359H25.8862V6.2729H1.05859V0.818359Z",
  fill: "#00B9E4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.8478 11.4545C14.3904 11.4545 15.6409 10.3556 15.6409 8.99996C15.6409 7.64435 14.3904 6.54541 12.8478 6.54541C11.3052 6.54541 10.0547 7.64435 10.0547 8.99996C10.0547 10.3556 11.3052 11.4545 12.8478 11.4545Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4682 11.0455C14.7537 11.0455 15.7958 10.1297 15.7958 9.00004C15.7958 7.87037 14.7537 6.95459 13.4682 6.95459C12.1827 6.95459 11.1406 7.87037 11.1406 9.00004C11.1406 10.1297 12.1827 11.0455 13.4682 11.0455Z",
  fill: "#ED2939"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9521 7.63672L16.2508 8.36967L17.05 8.03558L16.6698 8.74126L17.5038 9.00036L16.6698 9.26285L17.05 9.96513L16.2508 9.63104L15.9521 10.364L15.6534 9.63104L14.8543 9.96513L15.2344 9.26285L14.4004 9.00036L15.2344 8.73786L14.8543 8.03558L15.6534 8.36967L15.9521 7.63672Z",
  fill: "white"
})));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.96875,
  y: 0.5,
  width: 25,
  height: 17,
  rx: 1.5,
  stroke: "#E0E4E8"
});
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15653_6059"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.46875,
  y: 1,
  width: 24,
  height: 16,
  rx: 1,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_15653_6059"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.8276,
  height: 16.3636,
  fill: "white",
  transform: "translate(1.05469 0.818359)"
})));
function SvgAz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/az.6b1f28a3.svg";
export { ForwardRef as ReactComponent };